import { useContext } from 'react';
import { PreviewContext, PreviewDispatch } from './PreviewProvider';

export function usePreview() {
    const { preview } = useContext(PreviewContext);
    const { inherit, update, disable } = useContext(PreviewDispatch);

    return { preview, inherit, update, disable };
}
